const breadCrumb = "Exames - Exames para o Aluno";

const routes = [
  {
    path: "/exame-aluno",
    name: "exame-aluno",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAluno/ExameAlunoHome.vue"),
  },
  {
    path: "/exame-aluno/novo/:aluno_id/:escola_id",
    name: "exame-aluno-novo",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAluno/ExameAlunoCad.vue"),
  },
  {
    path: "/exame-aluno/editar/:id",
    name: "exame-aluno-editar",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAluno/ExameAlunoEdit.vue"),
  },
  {
    path: "/exame-aluno/disciplinas/:id",
    name: "exame-aluno-disciplinas",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameAluno/ExameAlunoDefinirDisciplinasListagem.vue"),
  },
  {
    path: "/exame-aluno/disciplinas/:exame_id/:estrutura_curricular_id/novo",
    name: "exame-aluno-disciplinas-novo",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameAluno/ExameAlunoDefinirDisciplinasCadastro.vue"),
  },
  {
    path: "/exame-aluno/visualizar/:exame_id/:escola_id",
    name: "exame-aluno-visualizar",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAluno/ExameAlunoConsultar.vue"),
  },
  {
    path: "/exame-aluno/emitir-comprovante/:exame_id/:escola_id",
    name: "exame-aluno-comprovante",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameAluno/ExameAlunoEmitirComprovante.vue"),
  },
  {
    path: "/exame-aluno/lancamento-notas/:exame_id",
    name: "exame-aluno-lancamento-notas",
    meta: {
      allowedPermissions: ["criar_nota_exame"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameAluno/ExameAlunoLancamentoNotas.vue"),
  },
];

export default routes;
